import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const termTypesService = {
    // get all term types
    getAllTermTypes: async () => {
        try {
            const response = await api.get(API_ENDPOINTS.TERMS_TYPES)
            return response.data || response
        } catch (error) {
            throw error;
        }
    }
}